<template>
    <div>
    <app-toolbarcustom app_title="Form Keluarga" app_menu="employeefamily"></app-toolbarcustom>
        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  :complete="steppers > 1"
                  step="1"
                >
                  Form
                </v-stepper-step>
          
                <v-divider></v-divider>
          
                <v-stepper-step
                  :complete="steppers > 2"
                  step="2"
                >
                  Summary
                </v-stepper-step>
                
              </v-stepper-header>
          
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card
                    class="mb-12 elevation-0"
                    height="200px"
                  >
                  <v-form enctype="multipart/form-data" ref="form_usersfamily_data" lazy-validation>
                  <v-row>
                    <!-- ID -->
                    <v-col cols="12" sm="6" md="12" class="mt-2">
                        <v-dialog
                        ref                 ="dialog_usersfamily_date"
                        v-model             ="modal.usersfamily_date"
                        :return-value.sync  ="form.usersfamily_date"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="usersfamily_date_value"
                            label               ="Tanggal Pengajuan"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_usersfamily_date"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.usersfamily_date" :min="$functions.Today()" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.usersfamily_date = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('usersfamily_date',form.usersfamily_date)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" class="mt-n6">
                    <v-dialog
                        ref="dialog_usersfamily_timein"
                        v-model="modal.usersfamily_timein"
                        :return-value.sync="form.usersfamily_timein"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="form.usersfamily_timein"
                            :rules="form.usersfamily_timein_rules"
                            label="IN *"
                            prepend-icon="access_time"
                            background-color="time"
                            readonly
                            v-on="on"
                            required 
                            outlined
                        ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="modal.usersfamily_timein"
                        v-model="form.usersfamily_timein"
                        format="24hr"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.usersfamily_timein = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog_usersfamily_timein.save(form.usersfamily_timein)">OK</v-btn>
                        </v-time-picker>
                    </v-dialog>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" class="mt-n6">
                        <v-dialog
                            ref="dialog_usersfamily_timeout"
                            v-model="modal.usersfamily_timeout"
                            :return-value.sync="form.usersfamily_timeout"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="form.usersfamily_timeout"
                                :rules="form.usersfamily_timeout_rules"
                                label="OUT *"
                                prepend-icon="access_time"
                                background-color="time"
                                readonly
                                v-on="on"
                                required 
                                outlined
                            ></v-text-field>
                            </template>
                            <v-time-picker
                            v-if="modal.usersfamily_timeout"
                            v-model="form.usersfamily_timeout"
                            format="24hr"
                            >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal.usersfamily_timeout = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog_usersfamily_timeout.save(form.usersfamily_timeout)">OK</v-btn>
                            </v-time-picker>
                        </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <v-text-field 
                                v-model="form.usersfamily_remarks"
                                :rules="form.usersfamily_remarks_rules"
                                prepend-icon="notes"
                                placeholder="Berikan Alasan Lembur"
                                label="Alasan Lembur *"
                                required
                                solo-inverted
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>  
                    </v-form>
                  </v-card>
                  <br>
                  <v-btn
                    color="primary"
                    @click="NextStep(1)"
                    block
                  >
                    Lanjut
                  </v-btn>
          
                </v-stepper-content>
          
                <v-stepper-content step="2">
                  <v-card
                    class="mb-12"
                    outlined
                  >
                  <v-card-title class="body-2 font-weight-bold">Ringkasan Lembur</v-card-title>

                    <v-card-text class="caption">
                            <v-row align="center">
                                <v-col cols="6">Tanggal Pengajuan</v-col><v-col cols="6" class="font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.usersfamily_date) }}</v-col>
                                <v-col cols="6" class="mt-n5">Jam Mulai</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.usersfamily_timein }}</v-col>
                                <v-col cols="6" class="mt-n5">Jam Selesai</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.usersfamily_timeout }}</v-col>
                                <v-col cols="6" class="mt-n5">Durasi</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ $functions.MinuteDiff(form.usersfamily_timein,form.usersfamily_timeout) }}</v-col>
                                <v-col cols="6" class="mt-n5">Alasan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.usersfamily_remarks }}</v-col>
                            </v-row>
                    </v-card-text>
                 </v-card>
          
                  <v-btn
                    color="primary"
                    @click="Confirm('add')"
                    block
                    class="mb-2"
                  >
                    Proses
                  </v-btn>
          
                  <v-btn color="secondary" @click="steppers = 1" block>
                    Sebelumnya
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
          <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            steppers: 1,
            url_type: 'add',
            current_date: '',
            form: {
                usersfamily_date: new Date().toISOString().substr(0, 10),
                usersfamily_date_rules: [v => !!v || 'Mohon isi Tanggal Lembur'],
                usersfamily_timein: '',
                usersfamily_timein_rules: [v => !!v || 'Mohon isi Jam Mulai'],
                usersfamily_timeout: '',
                usersfamily_timeout_rules: [v => !!v || 'Mohon isi Jam Selesai'],
                usersfamily_remarks: '',
                usersfamily_remarks_rules: [v => !!v || 'Mohon masukkan alasan lembur'],
                usersfamily_vehicle: 'P'
            },
            modal: {
                usersfamily_date: false,
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            }
        }),
         // Check If Back Button Press, Modal Close
         beforeRouteLeave (to, from, next) {
            if (this.modal.usersfamily_date || this.modal.usersfamily_timein || this.modal.usersfamily_timeout) {
                this.modal.usersfamily_date = false
                this.modal.usersfamily_timein = false
                this.modal.usersfamily_timeout = false
                next(false)
            } else {
                next()
            }
        },
        computed: {
            usersfamily_date_value () {
                return this.form.usersfamily_date ? this.$moment(this.form.usersfamily_date).format('LL') : ''
            }
        },
        methods: {
            GoTo (url) {
               this.$router.push(url)
            },
            Confirm (flag) {
                if (flag === 'add') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Proses'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                this.confirm.ok = 'Loading...'
                if (this.url_type === 'add' || this.url_type === 'edit') {
                    this.Write()
                }
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  usersfamily_date: this.form.usersfamily_date,
                  usersfamily_timein: this.form.usersfamily_timein,
                  usersfamily_timeout: this.form.usersfamily_timeout,
                  usersfamily_remarks: this.form.usersfamily_remarks,
                  usersfamily_vehicle: this.form.usersfamily_vehicle,
                  usersfamily_usersid: this.$functions.UsersID(),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteUsersFamily'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.SnackBar(true, 'success', 'Proses Sukses', 3000)
                            this.confirm.dialog  	 = false
                            this.confirm.text 	 	 = 'Ok'
                            let encodeurl = this.$functions.EncodeUrl(feedback[0].feedback_id)
                            this.$router.push({name: 'familydetail',params:{id:encodeurl}})
                        } else {
                            if (feedback[0].feedback === 'Please check absence Today') {
                                this.SnackBar(true, 'error', 'Mohon cek absen hari ini, pengajuan lembur tidak bisa jika sudah absen pulang atau belum absen datang', 0)
                            } else {
                                this.SnackBar(true, 'error', feedback[0].feedback, 0)
                            }
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'usersfamily_date':
                		this.$refs.dialog_usersfamily_date.save(value)
                        this.usersfamily_date = this.$moment(value).format('YYYY-MM-DD')
                    break
                }
            },
            NextStep(id) {
                if (id === 1) {
                    if (this.$refs.form_usersfamily_data.validate()) {
                    	if (this.form.usersfamily_timeout < this.form.usersfamily_timein) {
                    		this.snackbar.dialog = true
                            this.snackbar.text = 'Jam selesai tidak bisa kurang dari Jam mulai'
                    	} else {
                        	this.steppers = 2
                    	}
                    }
                }
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>